










import {
  Vue,
  Component
} from "@/shared/vuepack";
import { usePortalCustomizationStore } from "@/shared/store/portalCustomization";
import { useBankAccountStore } from "@/employee/store/bankAccount";
import { useUserStore } from "@/shared/store/user";

@Component
export default class BankAccountClosedAlert extends Vue {
  portalCustomizationStore = usePortalCustomizationStore();
  bankAccountStore = useBankAccountStore();
  userStore = useUserStore();

  mounted (): void {
    this.bankAccountStore.getBankAccountStatus();
  }

  get supportPhone (): string {
    return this.portalCustomizationStore.supportInfo.supportPhone;
  }

  get partnerName (): string {
    return this.portalCustomizationStore.supportInfo.displayName;
  }

  get showBankAccountClosureWarning (): boolean {
    return this.bankAccountStore.isBankAccountClosed && this.portalCustomizationStore.isSupportInfoLoaded;
  }
}
